exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fill-navy-blue {\n    background-color: #26273b;\n    background-size: cover;\n    box-shadow: 2px 3px 2px rgba(0,0,0,0.1);\n    padding: 10 0 10 20;    \n}\n\n.btn {\n    width: 27;\n    height: 27;\n    padding: 0;\n}\n\n.align-right {\n    text-align: end;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/scorm-cloud-player/scorm-cloud-player.component.css
// module id = 806
// module chunks = 0